import { HYDevice } from "@huyafed/huya-kiwi";
import dayjs from "dayjs";
export * from "./browser";

export const GETCOOKIE = name => {
  let arr,
    reg = new RegExp("(^| )" + name + "=([^;]*)(;|$)");
  if ((arr = document.cookie.match(reg))) return unescape(arr[2]);
  else return null;
};

export const urlParamsToObj = (
  url: string,
  decode = decodeURIComponent,
): { [key: string]: any } => {
  const params: { [key: string]: any } = {};
  url = url || window.location.href || "";
  if (!url) return params;
  const regex = /[?&]([^=#]+)=([^&#]*)/g;
  let match;
  while ((match = regex.exec(url)) !== null) {
    const key = decode(match[1]);
    const value = decode(match[2] || "");
    if (!(key in params)) {
      params[key] = value;
    }
  }
  return params;
};

export const objToUrlParams = (obj: { [key: string]: any }, prefix = "?") =>
  prefix.concat(
    Object.keys(obj)
      .map(key => `${key}=${obj[key]}`)
      .join("&"),
  );

export function getQueryString(name = "", url = window.location.search) {
  const params = urlParamsToObj(url);
  return params[name] || "";
}

export const getDebugFlag = () => {
  return getQueryString("useDebug");
};

const REM_ROOT_VALUE = 37.5;

export const px2rem = pxNum => {
  return pxNum / REM_ROOT_VALUE;
};

export function rem2px(rem: number, clientWidth?: number) {
  if (clientWidth === undefined) {
    clientWidth = document.documentElement.clientWidth;
  }
  var rootFontSize = clientWidth / 10;
  return rem * rootFontSize;
}

export const toRealPx = px => {
  return `${px2rem(px) * parseFloat(document.getElementsByTagName("html")[0].style.fontSize)}px`;
};

export const ROOT_RATE = () =>
  REM_ROOT_VALUE / parseFloat(document.getElementsByTagName("html")[0].style.fontSize);

export const toRootNum = (num: number) => num * ROOT_RATE();

export const UA = window.navigator.userAgent.toLowerCase();

export function debounceFn<T extends (...args: any[]) => any>(fn: T, delay: number = 100) {
  let timer: any;
  return function (...args: Parameters<T>) {
    clearTimeout(timer);
    timer = setTimeout(() => {
      fn(...args);
    }, delay);
  };
}

export function throttle<T extends (...args: any[]) => any>(cb: T, delay = 150) {
  let timer: any = null;
  return (...args: Parameters<T>) => {
    if (timer) return;
    timer = setTimeout(() => {
      cb(...args);
      timer = null;
    }, delay);
  };
}

export function once<T extends (...args: any[]) => any>(fn: T) {
  let result: ReturnType<T>;
  let e = false;
  return function (...args: Parameters<T>) {
    if (!e) {
      e = true;
      result = fn(...args);
    }
    return result;
  };
}

export function loadScript(url, attrs?) {
  return new Promise((resolve, reject) => {
    const matched = [...(window as any).document.scripts].find(script => script.src === url);
    if (matched) return resolve(true);
    const script = document.createElement("script");
    if (attrs) {
      Object.keys(attrs).forEach(name => {
        script.setAttribute(name, attrs[name]);
      });
    }
    script.type = "text/javascript";
    script.src = url;
    if ((script as any).onreadystatechange) {
      (script as any).onreadystatechange = resolve;
    }
    script.onload = resolve;
    script.onerror = reject;
    document.body.appendChild(script);
  });
}

export function numberWithCommasWithFixed(amount: any, fixed: number = 0) {
  const numberAmount = Number(amount);
  if (Number.isNaN(numberAmount)) return "";
  return numberAmount.toFixed(fixed).replace(/\B(?=(\d{3})+(?!\d))/g, ",");
}

export function numberWithCommas(amount: any) {
  const parts = amount.toString().split(".");
  parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ",");
  return parts.join(".");
}

export const formatTimeStamp = (timeStamp: string | number, mode = "YYYY-MM-DD HH:mm") => {
  try {
    return dayjs(new Date(Number(timeStamp) * 1000)).format(mode);
  } catch (error) {
    console.error("格式化时间戳错误", error);
    return "";
  }
};

export function localForDay<T = any>(key: string, value?: T) {
  const expireTimeDayMS = 1 * 1000 * 60 * 60 * 24;
  const busiKey = "@huyafed:guard-202211";
  const cacheKey = `${busiKey}:${key}`;
  const expireCacheKey = `${cacheKey}:expireCacheKey`;

  const getLocal = (nextKey = cacheKey): any => {
    try {
      return JSON.parse(localStorage.getItem(nextKey)!);
    } catch (error) {
      return undefined;
    }
  };
  const setLocal = (nextKey = cacheKey, value: any) => {
    try {
      localStorage.setItem(nextKey, JSON.stringify(value));
    } catch (error) {
      return;
    }
  };
  if (value === undefined) {
    const prevValue = getLocal(cacheKey);
    const prevExpireValue = getLocal(expireCacheKey);
    if (+new Date() - Number(prevExpireValue) >= expireTimeDayMS) {
      return undefined;
    }
    return prevValue;
  } else {
    setLocal(cacheKey, value);
    setLocal(expireCacheKey, +new Date());
  }
}

export const getDeviceInfo = () => {
  return new Promise<{
    androidid: string;
    openUDID: string;
    sUUID: string;
    sSdid: string;
    [key: string]: any;
  }>(resolve => {
    const defaultData = {
      androidid: "",
      openUDID: "",
      sUUID: "",
      sSdid: "",
    };
    HYDevice.getDeviceInfo()
      .then(resp => {
        resolve(resp);
      })
      .catch(_err => {
        resolve(defaultData);
      });
  });
};

export function unescapeHTML(str) {
  if (typeof str !== "string") return str;
  return str
    .replace(/</g, "<")
    .replace(/>/g, ">")
    .replace(/"/g, '"')
    .replace(/'/g, "'");
}
